const interpolateFallback = (value, params = {}) => (
    typeof value === 'string'
        ? value.replace(/\{([a-zA-Z0-9_]+)\}/g, (placeholder, key) => (
            Object.prototype.hasOwnProperty.call(params, key) ? params[key] : placeholder
        ))
        : value
)

const resolveStepText = (text, translate, params = {}) => {
    if (!text) {
        return null
    }

    const translatedText = text.key && typeof translate === 'function'
        ? translate(text.key, params)
        : null

    return translatedText && translatedText !== text.key
        ? translatedText
        : interpolateFallback(text.fallback, params)
}

const resolveStepTitle = (step, translate, params = {}) => resolveStepText(step.title, translate, params)

const resolveStepNavigationTitle = (step, translate, params = {}) => (
    resolveStepText(step.navigationTitle || step.title, translate, params)
)

const resolveStepDescription = (step, translate, params = {}) => (
    resolveStepText(step.description, translate, params)
)

const resolveStepNumberPrefix = (number, translate) => {
    const key = 'Component(Step):number-prefix'
    const translatedPrefix = typeof translate === 'function'
        ? translate(key, { number })
        : null

    return translatedPrefix && translatedPrefix !== key
        ? translatedPrefix
        : `Step ${number}`
}

const resolveStepHeading = (number, title, translate) => {
    const key = 'Component(Step):title-with-number'
    const translatedHeading = typeof translate === 'function'
        ? translate(key, { number, title })
        : null

    if (translatedHeading && translatedHeading !== key) {
        return translatedHeading
    }

    return `${resolveStepNumberPrefix(number, translate)} - ${title}`
}

export {
    resolveStepDescription,
    resolveStepHeading,
    resolveStepNavigationTitle,
    resolveStepNumberPrefix,
    resolveStepTitle,
}
export default resolveStepTitle
